import React, { Component } from 'react';
import { FloatButton, Popover } from 'antd';
import Icon from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './contact.scss';
import { ReactComponent as iconPhone } from "../../img/common/footer/icon_phone.svg";
import { ReactComponent as icon_wei } from "../../img/common/footer/icon_wei.svg";
import icon_expansion from "../../img/common/footer/icon-expansion.png";
import qrcodeImg from '../../img/common/footer/weixin_qrcode.png';
import official_account from "../../img/common/footer/official-account.jpg";
import qqImg from '../../img/common/float/btn_qq.svg';
import wxImg from '../../img/common/float/btn_wechat.svg';
import phoneImg from '../../img/common/float/iphone.svg';
export const contactData = [
    {
        title: "联系我们",
        icon: <Icon component={iconPhone} />,
        key: "tel",
        content: (
            <div className="nav-phone-content">
                <p style={{ textAlign: "center", color: "#000000", fontSize: 18, fontWeight: 500, marginBottom: 15, lineHeight: "28px" }}>联系我们</p>
                <p className="phone-work">
                    <img src={icon_expansion} />
                    <span>微信扫码咨询</span>
                </p>
                <p className="phone-num">
                    <Icon component={iconPhone} />
                    <span>19521468958</span>
                </p>
            </div>
        ),
    },
    {
        title: "公众号",
        icon: <Icon component={icon_wei} />,
        key: "wechat",
        content: (
            <div className="nav-wei-content">
                <p className="phone-work">
                    <img src={official_account} />
                    <span>微信扫码关注</span>
                </p>
            </div>
        ),
    },
];
class Contact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            key: "",
        }
        this.setKey = (key) => {
            this.setState({
                key: key,
            });
        }
    };
    render() {
        const QQContent = (
            <div className="QQContent">
                <h3 style={{ textAlign: 'center', color: '#5D6494', fontSize: '14px', fontWeight: '400' }}>官方QQ群</h3>
                <p>译筑技术服务群：535878696</p>
            </div>
        )

        const WXContent = (
            <div className="WXContent">
                <h3 style={{ textAlign: 'center', color: '#5D6494', fontSize: '14px', fontWeight: '400' }}>微信公众号</h3>
                <img style={{ display: 'inline-block', width: '#110px', height: '110px' }} src={qrcodeImg} alt="译筑官微" />
            </div>
        )

        return (
            <div className="contact-float">
                 <div className='contact-content'>
                    {contactData.map(item => (
                        <Popover
                            content={item.content}
                            key={item.key}
                            placement="rightTop"
                            arrow={false}
                            onOpenChange={open => this.setKey(open ? item.key : "")}
                            rootClassName={"nav-popover"}
                        >
                            <div className={`contact-item item-${item.key} ${this.state.key === item.key ? "active" : ""}`}>
                                <div className="contact-icon">{item?.icon}</div>
                                <div className="contact-title">{item.title}</div>
                            </div>
                        </Popover>
                    ))}
                </div>
            </div>)
    }
}
export default Contact